import React from 'react';

export default function ChatSidePanelInfoRow({
  label = '',
  value = null,
  valueClassName = 'side-info-val',
  rowClassName = 'side-info-row',
  keyClassName = 'side-info-key',
}) {
  return (
    <div className={rowClassName}>
      <span className={keyClassName}>{label}</span>
      <span className={valueClassName}>{value}</span>
    </div>
  );
}
